

import { Component, Vue, Prop } from "vue-property-decorator"

import { Feature } from "@/types/tenant"
import TenantFeatureItem from "./TenantFeatureItem.vue"

interface FeatureSection {
	section: string
	sectionKey: string
	features: Feature[]
}

@Component({
	components: {
		"feature-item": TenantFeatureItem
	}
})
export default class TenantFeatures extends Vue {
	@Prop({ default: [] })
	features!: Feature[]

	@Prop({ default: () => {} })
	value!: { [key: string]: boolean }

	filter: string | null = null
	visibleSections: { [key: string]: boolean } = {}

	get filteredFeatures () {
		if (!this.filter) return this.features

		const lowerFilter = this.filter.toLowerCase()
		return this.features.filter(f => f.title.toLowerCase().includes(lowerFilter) ||
			(f.taskId && f.taskId.toLowerCase().includes(lowerFilter)))
	}

	get options () {
		return this.features.map(feature => {
			return {
				text: feature.title,
				value: feature.key
			}
		})
	}

	get enabledFeatures (): Feature[] {
		return this.filteredFeatures.filter(f => this.value[f.key])
	}

	get disabledFeatures (): Feature[] {
		return this.filteredFeatures.filter(f => !this.value[f.key])
	}

	get enabledFeaturesBySection (): FeatureSection[] {
		const featuresGroupByTag = this.enabledFeatures.groupBy("tags")
		return Object.keys(featuresGroupByTag).map(group => {
			return {
				section: group || "Uncategorized",
				sectionKey: group.replace(" ", "-"),
				features: featuresGroupByTag[group]
			}
		}).sortBy("section")
	}

	featuresChanged (updatedList: string[]) {
		const updatedListItems = updatedList.filter(f => this.options.some(o => o.value === f))

		const oldValue = Object.keys(this.value).filter(f => this.value[f])
		const newValue = updatedListItems.reduce((p, c) => {
			p[c] = true
			return p
		}, {} as { [key: string]: boolean })

		if (oldValue.length !== updatedListItems.length || oldValue.some(o => !updatedListItems.includes(o))) {
			this.$emit("input", newValue)
		}
	}

	setEnabled (featureKey: string, checked: boolean) {
		console.log(featureKey, checked)
		Vue.set(this.value, featureKey, checked)
	}

	toggleVisible (sectionKey: string) {
		Vue.set(this.visibleSections, sectionKey, !this.visibleSections[sectionKey])
	}

	showHelp (feature: Feature) {
		this.$emit("showHelp", feature)
	}
}
